function devtricker_dom_set_changeCreateAccountButtonToLoading() {

    const button = devtricker_dom_get_createAccountButton();

    button.innerHTML = `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> ${g_devtricker_i18n.creating_account}`;
    button.disabled = true;
}

function devtricker_dom_set_changeCreateAccountButtonToOriginal() {

    const button = devtricker_dom_get_createAccountButton();

    button.innerHTML = g_devtricker_i18n.create_account;
    button.disabled = false;
}

function devtricker_dom_get_createAccountButton() {
    return document.getElementById('create-account-button');
}

function devtricker_dom_set_accountCreationErrorMessage(message) {

    const error = devtricker_dom_get_accountCreationErrorElement();

    error.textContent = message;
    error.style.display = 'block';
}

function devtricker_dom_set_hideAccountCreationErrorMessage() {

    const error = devtricker_dom_get_accountCreationErrorElement();

    error.style.display = 'none';
}

function devtricker_dom_get_accountCreationErrorElement() {
    return document.getElementById('accountCreateError');
}

function devtricker_dom_get_createAccountForm() {
    return document.getElementById('createAccountForm');
}

function devtricker_dom_get_createAccountUsernameInput() {
    return document.getElementById('signup-form-username');
}

function devtricker_dom_get_createAccountEmailInput() {
    return document.getElementById('signup-form-email');
}

function devtricker_dom_get_createAccountFullnameInput() {
    return document.getElementById('signup-form-fullname');
}

function devtricker_dom_get_createAccountUsernameErrorElement() {
    return document.getElementById('usernameError');
}

function devtricker_dom_get_getNearestInput(icon) {
    var parent = icon.closest('.input-group');
    var input = parent.querySelector('input');
    return input;
}

function devtricker_dom_set_createAccountToggleShowPassword(icon) {
    let input = devtricker_dom_get_getNearestInput(icon);

    const type = input.getAttribute('type') === 'password' ? 'text' : 'password';
    input.setAttribute('type', type);

    if (icon.classList.contains('icon-eye')) {
        icon.classList.remove('icon-eye');
        icon.classList.add('icon-eye-off');
    } else {
        icon.classList.remove('icon-eye-off');
        icon.classList.add('icon-eye');
    }
}

function devtricker_dom_set_changeCreateAccountInputToSuccess(input) {
    let errorE = devtricker_dom_get_closestInputErrorElement(input);
    
    input.classList.add('is-valid');
    input.classList.remove('is-invalid');
    if (errorE) errorE.style.display = 'none';
}

function devtricker_dom_set_clearCreateAccountInput(input) {
    let errorE = devtricker_dom_get_closestInputErrorElement(input);
    
    input.classList.remove('is-valid', 'is-invalid');
    if (errorE) errorE.style.display = 'none';
}

function devtricker_dom_set_changeCreateAccountInputToFail(input, message) {
    let errorE = devtricker_dom_get_closestInputErrorElement(input);
    
    input.classList.add('is-invalid');
    input.classList.remove('is-valid');
    
    if (errorE) {
        errorE.style.display = 'block';
        if (message) errorE.innerText = message;
    }
}

function devtricker_dom_get_closestInputErrorElement(input) {
    return input.closest('.form-group').querySelector('.error-message');
}

function devtricker_dom_set_clearTheCreatorModalOnClose() {
    var createAccountModal = document.getElementById('create-account-modal');

    if (createAccountModal) {
        createAccountModal.addEventListener('hide.bs.modal', function (event) {
            devtricker_dom_clearAllCreateAccountInputs();

            var strengthBars = document.querySelectorAll('.strength-bar');

            if (strengthBars) {
                strengthBars.forEach(bar => {
                    bar.className = 'strength-bar';
                });
            }
        });
    }
}

function devtricker_dom_clearAllCreateAccountInputs() {
    const form = devtricker_dom_get_createAccountForm();
    const inputs = form.querySelectorAll('input');

    inputs.forEach(input => {
        input.value = '';
        devtricker_dom_set_clearCreateAccountInput(input);
    });
}

function devtricker_dom_get_createAccountPasswordInput() {
    return document.getElementById('signup-form-password');
}